const parseFilterDataMapping = {
  created_on: 'created_on',
  company_id: 'company_id',
}

export default parseFilterDataMapping
